module.exports = __webpack_public_path__ + "assets/Rampur-hound-base.eaa08355.svg";